import client from "./client";
import { ClientSyncRun, ServiceOrderSyncResult } from "../interfaces/SyncStatus";

export function getSyncStatusErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const response = (err as { response?: { data?: { error?: string; message?: string } } }).response;
    if (response?.data?.error) return response.data.error;
    if (response?.data?.message) return response.data.message;
  }

  if (err instanceof Error) return err.message;
  return "An error occurred while loading sync status.";
}

export async function getSyncStatus(days?: number): Promise<ClientSyncRun[]> {
  const params = typeof days === "number" ? { days } : {};
  const response = await client.get<ClientSyncRun[]>("admin/syncStatus", { params });
  return response.data;
}

/**
 * TAS-516 — the on-demand Vista SM work-order + scope sync (the nightly timer runs the
 * same function). NPM only; every other tenant is answered 404 by the API, which is why
 * the button is behind `showServiceOrderSync` rather than offered everywhere.
 *
 * A run that has to touch every work order takes up to ~2 minutes, and the API allows
 * itself 5, so no client-side timeout is imposed here — the caller shows a running state
 * instead. Sync failures arrive as 200 + `success:false`; only the tenant gate and a
 * transport failure throw.
 */
export async function postServiceOrderSync(): Promise<ServiceOrderSyncResult> {
  const response = await client.post<ServiceOrderSyncResult>("admin/sync/serviceOrders");
  return response.data;
}
